import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import TableConsolidatedIncome from 'views/reports/informeConsolidatedIncome/tableInformeConsolidatedIncome';
import FilterConsolidatedIncome from 'views/reports/informeConsolidatedIncome/filterInformeConsolidatedIncome';
import { devConfig } from 'config/config'; // Importing development configuration
/**
 * Class representing the Reporte de Ingresos Consolidados Doradobet view.
 * @extends JetView
 */
export default class InformeConsolidateIncomeView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        /**
         * Configuration object for the toolbar.
         * Contains a pager and export options.
         */
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for the pager
                    autosize: false, // Disable autosize
                    height: 35, // Height of the pager
                    size: 10000, // Default page size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the rich select
                    id: 'Export', // Unique identifier for the rich select
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            if (value == 1) {
                                // Excel export
                                var table = $$('treetable'); // Reference to the table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de Ingresos Consolidados Doradobet'),
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de Ingresos Consolidados Doradobet'),
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Reporte de Ingresos Consolidados Doradobet'),
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('treetable'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de Ingresos Consolidados Doradobet'),
                                        autowidth: true,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset the rich select value
                        }.bind(this),
                    },
                },
            ],
        };

        /**
         * Configuration object for the left section of the view.
         * Contains a toolbar, filter, table, and additional toolbar.
         */
        const left = {
            css: 'int-left', // CSS class for styling
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // CSS class for styling based on the theme
                    elements: [
                        { view: 'label', label: _('Reporte de Ingresos Consolidados Doradobet') }, // Label component with text "Reporte de Ingresos Consolidados Doradobet"
                        {
                            type: 'wide', // Type of the component
                            css: 'close-bottom', // CSS class for styling
                            id: 'button-search', // Unique identifier for the search button
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20, // Bottom position
                                    right: 35, // Right position
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => {
                                        $$('filterPopup').show(); // Show the filter popup
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide', // Type of the component
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom position
                                    right: 35, // Right position
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event handler to navigate to the dashboard
                                },
                            ],
                        },
                    ],
                },
                FilterConsolidatedIncome, // Filter component
                TableConsolidatedIncome, // Table component
                toolbar, // Toolbar configuration
            ],
        };

        webix.ui.fullScreen(); // Enable full screen mode

        /**
         * Configuration object for the main view.
         * Contains a form with a responsive layout.
         */
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // Form component
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide', // Wide layout type
                    cols: [
                        left, // Left section configuration
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                $$('toolbar').hide(); // Hide the toolbar for small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide the search button for large screens
            }
        });
    }
}

// FILE DOCUMENTED
